export default __webpack_public_path__ + "static/media/agus.ae3c8a7d.mp3";